import { ISalaryScaleGroup, SalaryScaleGroupService } from "../../../services/salaryScaleGroup.service";
import { ISalaryScale, SalaryScaleService } from "../../../services/salaryScaleGroup.service";

interface IResolve {
    salaryScaleGroup?: ISalaryScaleGroup;
    salaryScale?: ISalaryScale;
    salaryScaleGroupId?: string;
}

class SalaryScaleDialogController {
    private resolve: IResolve;
    private salaryScaleGroup: ISalaryScaleGroup;
    private salaryScale: ISalaryScale;
    private isEditMode: boolean;

    constructor(
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private SalaryScaleService: SalaryScaleService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
    ) {
        'ngInject';
    }

    public $onInit = () => {
        const groupId = this.$stateParams['groupId'] || (this.resolve && this.resolve.salaryScaleGroupId);
        const scaleId = this.$stateParams['id'];
        
        if (groupId) {
            // Editing or creating a salary scale within a group
            this.isEditMode = false;
            if (this.resolve && this.resolve.salaryScale) {
                // Edit existing scale from resolve
                this.salaryScale = this.resolve.salaryScale;
                this.isEditMode = true;
            } else if (scaleId && scaleId !== '' && scaleId !== null && scaleId !== undefined && scaleId !== 'null') {
                // Edit existing scale - load from API
                this.SalaryScaleService.get(scaleId).then((scale: ISalaryScale) => {
                    this.salaryScale = scale;
                    this.isEditMode = true;
                });
            } else {
                // Create new scale
                this.salaryScale = {
                    id: undefined,
                    salaryScaleGroupId: groupId,
                    code: '',
                    name: '',
                    hourlyWage: 0,
                    conversionFactor: 0
                } as ISalaryScale;
            }
        } else {
            // Editing or creating a salary scale group (CAO)
            this.isEditMode = false;
            if (this.resolve && this.resolve.salaryScaleGroup) {
                // Edit existing group from resolve
                this.salaryScaleGroup = this.resolve.salaryScaleGroup;
                this.isEditMode = true;
            } else {
                const groupIdParam = this.$stateParams['id'];
                if (groupIdParam && groupIdParam !== '') {
                    // Edit existing group - load from API
                    this.SalaryScaleGroupService.get(groupIdParam).then((group: ISalaryScaleGroup) => {
                        this.salaryScaleGroup = group;
                        this.isEditMode = true;
                    });
                } else {
                    // Create new group
                    this.salaryScaleGroup = {
                        id: undefined,
                        name: '',
                        description: '',
                        isDefaultNmbrsCao: false
                    } as ISalaryScaleGroup;
                }
            }
        }
    }

    submitSalaryScaleGroup() {
        if (this.salaryScaleGroup.id === undefined) {
            this.SalaryScaleGroupService.post(this.salaryScaleGroup).then((result: any) => {
                this.$state.go('^', { }, {reload: true});
            });
        } else {
            this.SalaryScaleGroupService.put(this.salaryScaleGroup.id, this.salaryScaleGroup).then(result => {
                this.$state.go('^', { }, {reload: true});
            });
        }
    }

    submitSalaryScale() {
        if (this.salaryScale.id === undefined) {
            this.SalaryScaleService.post(this.salaryScale).then((result: any) => {
                this.$state.go('^', { }, {reload: true});
            });
        } else {
            this.SalaryScaleService.put(this.salaryScale.id, this.salaryScale).then(result => {
                this.$state.go('^', { }, {reload: true});
            });
        }
    }

    deleteSalaryScaleGroup() {
        this.SalaryScaleGroupService.delete(this.salaryScaleGroup.id).then((result: any) => {
            this.$state.go('^', { }, {reload: true});
        });
    }

    deleteSalaryScale() {
        this.SalaryScaleService.delete(this.salaryScale.id).then((result: any) => {
            this.$state.go('^', { }, {reload: true});
        });
    }

    onDefaultNmbrsCaoChange() {
        // Als deze CAO wordt gemarkeerd als default, zorg dat andere CAO's niet meer default zijn
        if (this.salaryScaleGroup && this.salaryScaleGroup.isDefaultNmbrsCao) {
            // Haal alle CAO's op en zet andere op false
            this.SalaryScaleGroupService.all().then((groups: ISalaryScaleGroup[]) => {
                const otherGroups = groups.filter(g => g.id !== this.salaryScaleGroup.id && g.isDefaultNmbrsCao);
                // Update andere CAO's die default waren
                otherGroups.forEach(group => {
                    group.isDefaultNmbrsCao = false;
                    this.SalaryScaleGroupService.put(group.id, group);
                });
            });
        }
    }
}

export const salaryScalesDialogComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: SalaryScaleDialogController,
    template: require('./salaryScale.dialog.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/salaryScales/salaryScale.dialog.component.ts